import { PartsList } from './PartsList';

export default PartsList;
